import React, { Component } from "react";
import Dialog from "../dialog";
import DialogInput from "../input";
import LanguageInput from "../languagesinput";
import { onGoToHomeOrEnd } from "../../appcode/appcomponents/transcript/actions/cursor";


class AddDocument extends Dialog
{
  constructor(props) 
  {
    super(props);

    var title = {
        en:"Add a document", 
        fr:"Ajouter un document",
      };


      if (this.props.edit)
        title = {
            en: "Edit a document", 
            fr: "Modifier un document",
        }
    this.state.title = title;

    this.state.buttons = 
    [
      //{type:"text", disabled:true,text:{fr:"Accepter",en:"Accept"},key:"accept"},
      //{type:"text", disabled:false,text:{fr:"Refuser",en:"Decline"}, key:"decline"},
      {type:"back", disabled:false},
      {type:"ok", disabled:true},
      
    ]

    this.handleButton =  this.handleButton.bind(this);

    this.formulaire = 
      {
        title: "",
        type: 9,
        documentFileName: "",
        language: "fr-FR",
        uploadfile: null,
        ext: '',
      }


        console.log("adddocument formulaire : ", this.props)

        if (this.props.edit)
        {
            this.formulaire.documentFileName = this.props.asset.asfile;
            this.formulaire.title = this.props.asset.astitle;
            this.formulaire.ext = this.props.asset.asext;

        }
        else
        {
            this.formulaire.uploadfile = this.props.documentDatas;
            this.formulaire.documentFileName = this.props.documentFileName;
            this.formulaire.title = this.removeExtension(this.props.documentFileName);
            this.formulaire.ext = this.getFileExtension(this.props.documentDatas);
        }
        
      this.titleRef = React.createRef();
      this.uploadRef = React.createRef();
      this.filenameRef = React.createRef();
      this.languageRef = React.createRef();

      this.handleOnChange = this.handleOnChange.bind(this);

      this.onQuit = this.onQuit.bind(this)
      this.onValid = this.onValid.bind(this)


   
    
  }
  getFileExtension(file)
  {
      const filename = file.name; // Get the file name
      const index = filename.indexOf(".");
      if (index === -1) return "";

      const fileExtension = filename.split(".").pop().toLowerCase(); // Extract the file extension
      return fileExtension;

  }


  onValid()
  {
    
  }

  onQuit()
  {
    this.props.onButton("back", this.formulaire);    
  }

  removeExtension(filename) 
    {
      const index = filename.indexOf(".");
      if (index === -1) return filename;
      return filename.split('.').slice(0, -1).join('.');
    }

  handleOnChange()
  {
      this.formulaire.title = this.titleRef.current.getValue();

    this.filenameRef.current.setValue(this.formulaire.documentFileName)
      
      this.formulaire.language = this.languageRef.current.getValue();
      




      if ((this.formulaire.title.trim() !== "")
        && (this.formulaire.uploadfile !== null))
      {
        this.setDisabledButtonByType("ok", false);
        this.setDisabledButtonByKey("accept", false);
      }
      else
      {
        if ((this.formulaire.title.trim() !== "") && (this.props.edit))
        {
            this.setDisabledButtonByType("ok", false);
            this.setDisabledButtonByKey("accept", false);

        }
        else
        {
            this.setDisabledButtonByType("ok", true);
            this.setDisabledButtonByKey("accept", true);
        }
      }

      
  }


  handleButton(buttonkey)
  {

    if (this.props.edit)
    {
        var newformulaire = 
          {
            id: this.props.asset.asid,
            title: this.formulaire.title,
            type: this.props.asset.astype,
            filename: this.props.asset.asfile,
            uploadfile: null,
            ext: this.props.asset.asext,
            subtype:this.props.asset.assubtype,
            orititle: this.props.orititle,
            language: this.formulaire.language,
            framerate: "",
            timecode: this.props.asset.astimecode,
            config: this.props.asset.ascoid,
          }
          this.props.onButton(buttonkey, newformulaire);
    }
    else
      this.props.onButton(buttonkey, this.formulaire);



  }

  render()
  {


    const retour =
    (
      <>
      <br/>
        <DialogInput
          value = {this.formulaire.title}
          disabled={false}
          autoFocus = {true}
          title = {this.context.language=="fr"?"Titre":"Title"}
          width = "400px"
          ref = {this.titleRef}
          onChange =  {this.handleOnChange}

        />
    <br/>

      <DialogInput
                value = {this.formulaire.filename}
                disabled={false}
                autoFocus = {false}
                ref = {this.filenameRef}
                onChange =  {this.handleOnChange}
                readOnly = {true}
                width = "400px"
                title = {this.context.language=="fr"?"Fichier original":"Original file"}
              />

      <LanguageInput
                value = {this.formulaire.language}
                disabled={false}
                autoFocus = {false}
                ref = {this.languageRef}
                onChange =  {this.handleOnChange}
                readOnly = {false}
                width = "400px"
                title = {this.context.language=="fr"?"Langage":"File to Language"}
              />


      

      </>
    )

    return super.render(retour);
  }


}

AddDocument.defaultProps = {
    edit: false,
    asset: {asid:0},
}
export default AddDocument;